import React from 'react';
import InfoBlock from '../Shared/InfoBlock';

const isEmpty = (val) => !val || val.trim() === '';

const formatZip = (zip) => {
    if (!zip) return '';
    const cleaned = zip.toString().replace(/\D/g, ''); // remove non-digits
    return cleaned.length > 5
        ? `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`
        : cleaned;
};

const BeneCard = ({ title, person }) => {
    if (!person) return null;

    const displayType = person.type === 'C' ? 'Contingent' : 'Primary';

    const hasAddress = person.address1 || person.address2 || person.city || person.state || person.zip;
    const displayAddress = hasAddress ? (
        <>
            {person.address1 && <>{person.address1}<br /></>}
            {person.address2 && <>{person.address2}<br /></>}
            {(person.city || person.state || person.zip) && (
                <>
                    {[person.city, person.state].filter(Boolean).join(', ')} {formatZip(person.zip)}
                </>
            )}
        </>
    ) : null;


    return (
        <div className="personCard">
            <div className="personCardHeader">{title}</div>
            <div className="personCardBody">
                <InfoBlock label="Name:" value={person.displayName || ''} />
                <InfoBlock label="DOB:" value={person.birthDate || ''} />
                <InfoBlock label="Phone:" value={person.phone || ''} />
                <InfoBlock label="Email:" value={person.email || ''} />
                <InfoBlock label="Type:" value={displayType || ''} />
                <InfoBlock label="Percentage:" value={person.percentage ? `${person.percentage}%` : ''} />
                <InfoBlock label="Relationship:" value={person.relationship || ''} />
                <InfoBlock label="Address:" value={displayAddress} />
            </div>
        </div>
    );
};

export default BeneCard;
